<ng-container class=" col-md-6 col-sm-12 student-input" *ngIf="!props.isHidden">
  <label class="form-control-label">{{ props.label }} <span *ngIf="props.required && props.label">*</span></label>
<!-- {{props.readOnly}} -->
  <ng-select  class=" input-group"  bindLabel="{{ props.bindLabel }}" formControlName="{{ props.field_Name }}"
      bindValue="{{ props.bindValue }}" [appendTo]="body" placeholder="Select" [readonly]="props.readOnly" [multiple]="props.propIsMultiSelect" [searchable]="true"
      [clearable]="props.propIsMultiSelect" (change)="onMaterialGroupChange($event)" [items]="props.options" 
       >      <option value="" selected> {{ props.label ? props.label : props.propcustom ? props.propcustom : 'Select' }}</option>

     
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div class="ng-value" *ngFor="let item of items">
              <span class="ng-value-label">{{item[props.bindLabel]}}</span>
              <span class="ng-value-icon right"  *ngIf="props.propIsMultiSelect" (click)="clear(item)" aria-hidden="true">×</span>
          </div>
          <!-- <div class="ng-value" *ngIf="items.length > 3">
              <span class="ng-value-label">+ {{items.length - 3}} more...</span>
          </div> -->
      </ng-template>
  </ng-select>
  <!-- <sm-error [control]="formcontrol"></sm-error> -->
  <sm-error [control]="formcontrol" [label]="props.label"></sm-error>


</ng-container>
<!-- <ng-container class="col-md-6 col-sm-12 student-input" *ngIf="!props.isHidden">
  <label class="form-control-label"
    >{{ props.label }} <span *ngIf="props.required">*</span></label
  >

  <ng-select
    #ngSelect
    class="input-group"
    [selectableGroup]="true"
    [selectableGroupAsModel]="false"
    bindLabel="{{ props.bindLabel }}"
    formControlName="{{ props.field_Name }}"
    bindValue="{{ props.bindValue }}"
    appendTo="body"
    placeholder="Select"
    [readonly]="props.readOnly"
    [multiple]="true"
    [searchable]="true"
    [clearable]="true"
    (change)="onMaterialGroupChange($event)"
    [items]="props.options"
  >
    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <div *ngIf="item.student_id === 'selectAll'">
        <input
          id="select-all"
          type="checkbox"
          (click)="onSelectAllChange($event, ngSelect)"
          [checked]="areAllSelected()"
        />
        <span (click)="onSelectAllChange({ target: { checked: true } }, ngSelect)"> {{ item[props.bindLabel] }} </span>      </div>
      <div *ngIf="item.student_id !== 'selectAll'">
        <input
          id="item-{{ item.student_id }}"
          type="checkbox"
          [checked]="item$.selected"
        />
        {{ item[props.bindLabel] }}
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of items">
        <span class="ng-value-label">{{ item[props.bindLabel] }}</span>
        <span
          class="ng-value-icon right"
          (click)="clear(item)"
          aria-hidden="true"
          >×</span
        >
      </div>
    </ng-template>
  </ng-select>
  <sm-error [control]="formcontrol"></sm-error>
</ng-container> -->
